import { Typography } from "antd";
import { PhoneButton } from "../InformationRequest/LeadButtons/PhoneButton/web";
import { OwnerLogo } from "../OwnerLogo/web";
import "./styles.less";
import { useContext } from "react";
import { ConfigStateContext } from "shared-components/Contexts/Configurations/context";
import { getInmoLink } from "src/utils/Functions";

const { Text } = Typography;

export const OwnerInfo = ({ owner = null, id, mode, disabled = false, isProject = false }: { owner?: Owner; id; mode, disabled?: boolean, isProject?: boolean }) => {
	if (owner == null) return null;
	const { country_code } = useContext(ConfigStateContext);
	const inmoLink = country_code === "CO" && owner.particular == false ? getInmoLink(owner.id, owner.name) : owner.inmoLink;

	return (
		<div className="owner-info">
			{/* @ts-ignore */}
			{owner?.logo && owner?.__typename !== "Individual" && (
				<OwnerLogo
					inmoLink={inmoLink}
					inmoPropsLink={owner.inmoLinkProps}
					logo={owner.logo}
					type="full"
					name={owner.name}
					inmoFull={owner.inmofull}
				/>
			)}
			{/* <div className="owner-data">
				<Text
					ellipsis
					className="owner-name"
					children={owner ? owner.name : ""}
					title={owner ? owner.name : ""}
				/>
			</div> */}
		</div>
	);
};
